import * as React from 'react';
import gettext from '@sdk/lang/gettext';
import Picker from '@sdk/components/forms/Picker';
import Column from '@sdk/components/ui/spacing/Column';
import Text14 from '@sdk/components/ui/typography/Text14';
import Row from '@sdk/components/ui/spacing/Row';
import { WEEKDAYS_OPTIONS } from '@sdk/common/constants';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import SettingsSection from '../../../settings/components/SettingsSection';
import { FIELD_WIDTH_150 } from '../../../settings/constants';

import type { FirstDayOfWeekField } from './types/OrgSettingsFields';

type Props = {
  firstDayOfWeekField: FirstDayOfWeekField;
};

const FirstDayOfWeek: React.FC<React.PropsWithChildren<Props>> = ({ firstDayOfWeekField }) => (
  <SettingsSection withSeparator pTop={20}>
    <Row justifyContent="space-between" alignItems="center">
      <Column>
        <Text14 semiBold themeColor={ThemeColorType.gray}>
          {gettext('First day of the week')}
        </Text14>
        <Text14 themeColor={ThemeColorType.gray}>
          {gettext('Affects your schedule layout and labor cost calculation.')}
        </Text14>
      </Column>

      <Picker
        options={WEEKDAYS_OPTIONS}
        value={firstDayOfWeekField.value}
        customWidth={FIELD_WIDTH_150}
        onChange={(value: number): void => firstDayOfWeekField.onChange(value)}
      />
    </Row>
  </SettingsSection>
);

export default FirstDayOfWeek;
